module.exports = __webpack_public_path__ + "img/shopline-logo.177f6d30.svg";